import styled from 'styled-components';

const WrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 48px 24px;
  border-top: 1px #c9cfd7 solid;
  width: 100%;
`;

const SvgHeaderWrapperStyled = styled.div`
  margin: 0px 0px 42px;
  > img {
    width: 100%;
  }
`;

const ContentWrapperStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
`;

const TextBlockStyled = styled.div`
  border: 1px solid #c9cfd7;
  width: 100%;
  height: 196px;
  background-color: #fff;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 24px;
  color: #494c66;
  font-size: 14px;
  font-weight: 300;
  line-height: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  > p {
    text-align: center;
    strong {
      font-weight: 600;
    }
  }
  @media (min-width: 769px) {
    width: 48%;
  }
`;

const AltStrongStyled = styled.strong`
  display: block;
  color: #494c66;
  margin-top: 15px;
`;

const ActivatorPanelText = styled.div`
  cursor: pointer;
  > p {
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    text-decoration-line: underline;
    color: #e92070;
    weight: 400;
  }
`;

export {
  WrapperStyled,
  SvgHeaderWrapperStyled,
  ContentWrapperStyled,
  TextBlockStyled,
  AltStrongStyled,
  ActivatorPanelText,
};
